export default __webpack_public_path__ + "static/media/main_item_04.233e5e7d.png";